var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityheart11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 40,
    viewBox: "0 0 55 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M55 0H0V40H55V0Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8621 6.80769L26.0296 5.98192C22.401 2.20374 16.2934 1.98677 12.388 5.49719C12.215 5.65281 12.0478 5.81443 11.887 5.98192C8.03767 9.99859 8.03767 16.2062 11.887 20.2229C11.887 20.2229 26.2241 34.7308 26.8621 35.3654C27.5 36 26.8621 6.80769 26.8621 6.80769Z",
    fill: "#F1CCED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8847 5.98234C40.9141 4.08408 38.1528 3.004 35.2598 3C32.3645 3.003 29.6003 4.08251 27.6267 5.98112L26.8623 6.80711C26.8623 6.80711 26.8623 31.5579 26.8623 35.3652C27.5002 34.7306 27.6011 34.6387 27.8905 34.393C27.9083 34.3779 27.9257 34.3623 27.9426 34.3463C27.9426 34.3463 29.5431 32.8331 30.3433 32.0766C34.5238 28.1241 42.8847 20.2192 42.8847 20.2192C47.0387 16.2038 47.0387 9.99778 42.8847 5.98234Z",
    fill: "#FF8DB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9657 15.6924H21.7588V18.2308H31.9657V15.6924Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1381 11.8843H25.5864V22.0381H28.1381V11.8843Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityheart11);
export default __webpack_public_path__ + "static/media/securityheart 1 (1).dfcb81cc677bbeb378a183e977a77e68.svg";
export { ForwardRef as ReactComponent };